import { Pack, PackTier } from '~/util/types/packs';

export function createOGPackPayload({
    pack,
    tier,
}: {
    pack: Pack;
    tier: PackTier;
}) {
    return {
        pack,
        tier: {
            id: tier.id,
            name: tier.name,
            color: tier.color,
        },
    };
}
